var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Divider',{attrs:{"orientation":"left"}},[_vm._v("富文本")]),_c('Form',{staticClass:"c-form c-form--dress",attrs:{"label-width":80}},[_c('Form-item',{attrs:{"label":"内容","prop":"content"}},[_c('c-editor',{attrs:{"html":_vm.props.content},on:{"change":function (html) {
            _vm.$set(_vm.props, 'content', html);
          }}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }